import { action, makeAutoObservable } from 'mobx';
import { fetchRecommendedCandidates, inviteCandidateToJobPosting } from '../api/SlmService';
import notificationStore from './NotificationStore';

class RecommendedCandidatesStore {

  candidates = [];

  paginationInfo = {};

  isLoading = false;

  page = 1;

  notificationStore = {};

  constructor(newNotificationStore) {
    makeAutoObservable(this);
    this.notificationStore = newNotificationStore;
  }

  setCandidates = (list) => {
    this.candidates = list;
  };

  setPaginationInfo = (paginationInfo) => {
    this.paginationInfo = paginationInfo;
  };

  setIsLoading = (isLoading) => {
    this.isLoading = isLoading;
  };

  setPage = (page) => {
    this.page = page;
  };

  fetchRecommendedCandidates = (jobPostingId, withLoader = true) => {
    if (withLoader) {
      this.setIsLoading(true);
    }
    fetchRecommendedCandidates(jobPostingId, this.page).then(
      action('success', (data) => {
        this.setPaginationInfo(data?.metadata?.paginationInfo);
        this.setCandidates(data?.briefCandidateInfos);
      }),
      action('error', () => {
        this.notificationStore.setError('Failed to retrieve recommended candidates.');
      })
    ).finally(() => {
      this.setIsLoading(false);
    });
  };

  flushRecommendedCandidates = () => {
    this.candidates = [];
  };

  inviteCandidateToJobPosting = (jobPostingId, candidateId) => {
    inviteCandidateToJobPosting(jobPostingId, candidateId).then(
      action('success', () => {
        this.fetchRecommendedCandidates(jobPostingId);
      }),
      action('error', () => {
        notificationStore.setError('Failed to invite candidates.');
      })
    );
  };
}

export default new RecommendedCandidatesStore(notificationStore);
